import { useEffect, useState } from 'react';
import { useIsomorphicLayoutEffect } from '@toss/react';
import cns from 'classnames';
import { useRouter } from 'next/router';
import { event } from '@zep/analytics';
import { logger } from '@zep/core-logger';
import { useColorContrastHelper, useViewportDevice } from '@zep/react';
import { Carousel } from '@zep/web-components';
import { BannerSchemaType } from './BannerSchema';
import S from './BannerSlider.module.scss';
const DEFAULT_CTA_LABEL_BY_LOCALE: Record<string, string> = {
  ko: '바로가기',
  en: 'Go',
  ja: '開く'
};
export const Banner = (props: BannerProps) => {
  const {
    banner,
    isVisible,
    onRequestFocus
  } = props;
  const {
    id,
    title,
    title_mobile,
    description,
    description_mobile,
    backgroundColor,
    mode,
    image,
    url,
    cta_label,
    button_label
  } = banner;
  const {
    locale
  } = useRouter();
  const {
    isPortableDevice
  } = useViewportDevice();
  const [isMobileUi, setMobileUi] = useState(false);
  const ctaLabel = cta_label || button_label || DEFAULT_CTA_LABEL_BY_LOCALE[locale ?? 'ko'] || DEFAULT_CTA_LABEL_BY_LOCALE.en;
  const onClickBanner = () => {
    if (isVisible) {
      logger.track('home_banner_click', {
        title
      });
      event(`ad_home_banner_click_${id}`);
      window.open(url, '_blank');
    } else {
      onRequestFocus();
    }
  };
  const {
    isDarkBackground,
    transparentColor
  } = useColorContrastHelper(backgroundColor, mode);
  useIsomorphicLayoutEffect(() => {
    // FIXME: SSR Hydration 중 문제가 발생해서 state로 한번 감싸서 사용
    setMobileUi(isPortableDevice);
  }, [isPortableDevice]);
  useEffect(() => {
    if (isVisible) {
      event(`ad_home_banner_view`);
      event(`ad_home_banner_view_${id}`);
    }
  }, [id, isVisible]);
  return <Carousel.Slide className={cns(S.slide, {
    [S.visible]: isVisible
  })} data-dark={isDarkBackground} onClick={onClickBanner} data-sentry-element="unknown" data-sentry-component="Banner" data-sentry-source-file="Banner.tsx">
      <div className={S.content_wrapper}>
        <div className={S.content} style={{
        backgroundColor
      }}>
          <div className={S.text_wrapper}>
            <span className={S.title}>
              {isMobileUi ? title_mobile || title : title}
            </span>
            <span className={S.description}>
              {isMobileUi ? description_mobile || description : description}
            </span>
          </div>
        </div>
        <div className={S.gradient} style={{
        background: `linear-gradient(${isMobileUi ? 'to top' : 'to right'}, ${backgroundColor} 1px, ${transparentColor})`
      }} />
      </div>
      <div className={S.image} style={{
      backgroundImage: `url(${image})`
    }} />
      {!isMobileUi && <div className={S.cta_button}>{ctaLabel}</div>}
      <div className={S.border} />
    </Carousel.Slide>;
};
type BannerProps = {
  banner: BannerSchemaType;
  isVisible: boolean;
  onRequestFocus: () => void;
};